var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{attrs:{"label":_vm.data.fieldname}},[_c('a-input',{staticClass:"input",attrs:{"type":_vm.data.fieldtype ==='number' ? 'number' : 'text',"placeholder":_vm.placeholder,"disabled":_vm.data.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }